import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

const THeadLoader: React.FC = () => (
  <div className="tanstack-table--thead">
    <div className="tanstack-table--tr">
      {[1, 2, 3, 4, 5, 6].map((key) => (
        <div className="tanstack-table--th" key={key} style={{ flex: '1' }}>
          <div className="column-header-content loading">
            <SkeletonLoading width={100} height={20} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default THeadLoader;
